import MainStyles from '../../../../ArticlesComponents/ArticleWrapper/styles.module.scss';

import withComponentName from '../../../../../decorators/withComponentName';

export function Schedule1() {
  return (
    <>
      <h2 className={MainStyles.title} style={{ paddingTop: '0' }}>Terms applicable to consumer and sole-trader customers&quot;</h2>
      <section className={MainStyles.article}>
        <p>
          If you are consumer Customer using the Services for non-business purposes or if&nbsp;
          you are a sole-trader Customer, the additional terms set out here are applicable&nbsp;
          to you.  In the event of a conflict between the terms set out in this schedule and&nbsp;
          those elsewhere in the Contract for Services, the terms of this schedule shall prevail.
        </p>
      </section>
      <h2 className={MainStyles.title}>Contacting us if you are a consumer</h2>
      <section className={MainStyles.article}>
        <p>
          To cancel a Contract in accordance with your legal right to do so&nbsp;
          (as described in more detail below), you just need to let us&nbsp;
          know that you have decided to cancel. You need
          to do this by logging into your account and cancelling the contract through the&nbsp;
          Application control panel. We will e-mail you to&nbsp;
          confirm we have received your cancellation.
          <br />
          <br />
          If you wish to contact us for any other reason,&nbsp;
          including because you have any complaints,&nbsp;
          you can contact us by telephoning our&nbsp;
          customer service team using any of the numbers published on our website contacting us
          <a href="/contact-us" className={MainStyles['form-toggle']}>here.</a>
        </p>
      </section>
      <h2 className={MainStyles.title}>Your consumer right to cancel and receive a refund</h2>
      <section className={MainStyles.article}>
        <p>
          If you are a consumer, you have a legal right to cancel a Contract. This means that&nbsp;
          during the relevant period if you change your mind or decide for any other reason&nbsp;
          that you do not want to receive the Services, you can notify us of your decision&nbsp;
          to cancel the Contract and (if sums have been paid in advance) receive a refund.
          <br />
          <br />
          In relation to the Services, which are not completed services and which you can&nbsp;
          subsequently choose to cancel, you shall be liable for fees applicable to the&nbsp;
          proportion of the Services that have been delivered to you up until you communicate&nbsp;
          your cancellation; this may include costs incurred by Information Service Provider&nbsp;
          to its suppliers and Information Service Providers.
          <br />
          <br />
          More advice about your legal right to cancel the Contract is available&nbsp;
          from your local Citizens&apos; Advice Bureau or Trading Standards office.
        </p>
      </section>
      <h2 className={MainStyles.title}>Our liability if you are a consumer or sole-trader</h2>
      <section className={MainStyles.article}>
        <div>
          You have legal rights in relation to Services that are not as described.&nbsp;
          These legal rights are not affected by your right of refund above or&nbsp;
          anything else in this Contract.
          <br />
          <br />
          If Information Service Provider fails to comply with the terms of this&nbsp;
          Contract, it is responsible for loss or damage you suffer that is a foreseeable&nbsp;
          result of such breach of contract or negligence but Information Service Provider&nbsp;
          is not responsible for any loss or damage that is not foreseeable. Loss or damage is&nbsp;
          foreseeable if it is an obvious consequence of the breach or if it was&nbsp;
          contemplated by you and Information Service Provider at the time you signed this Contract.
          <br />
          <br />
          Information Service Provider only supplies the Services to consumer&nbsp;
          Customers for domestic and private use. If you are a consumer Customer, you&nbsp;
          agree not to use the product for any commercial, business or resale purposes&nbsp;
          and, if you are a consumer or sole-trader, you accept that Information&nbsp;
          Service Provider has no liability to you for any loss of profit, loss&nbsp;
          of business, business interruption, or loss of business opportunity.
          <br />
          <br />
          Information Service Provider does not in any way exclude&nbsp;
          or limit its liability to you for:
          <br />
          <br />
          <ul>
            <li>death or personal injury caused by its negligence;</li>
            <li>fraud or fraudulent misrepresentation;</li>
            <li>
              any breach of the terms implied by section 12 of the Sale of&nbsp;
              Goods Act 1979 (title and quiet possession) if applicable to the Services;
            </li>
            <li>
              any breach of the terms implied by section 13 to 15 of the&nbsp;
              Sale of Goods Act 1979 (description, satisfactory quality,&nbsp;
              fitness for purpose and samples) if applicable to the Services; and
            </li>
            <li>
              defective products under the Consumer Protection&nbsp;
              Act 1987 if applicable to the Services.
            </li>
          </ul>
        </div>
      </section>
    </>
  );
}

export default withComponentName(Schedule1);
